import { ValuesMap } from '@/common/types';
import currentTheme from '@/styles/theme';
export enum ResendItemType {
  Email = 'EMAIL',
  Letter = 'LETTER',
  SMS = 'SMS',
}

export enum ResendItemStatus {
  NotSent = 'NOT_SENT',
  Sent = 'SENT',
  Cancelled = 'CANCELLED',
  Archived = 'ARCHIVED',
  Read = 'READ',
  Resent = 'RESENT',
  Sending = 'SENDING',
  Bounced = 'BOUNCED',
  Delivered = 'DELIVERED',
  Opened = 'OPENED',
  ReportedAsSpam = 'REPORTED_AS_SPAM',
  Unsubscribed = 'UNSUBSCRIBED',
  Processing = 'PROCESSING',
}

export const ResendItemStatusBackgroundColorMap: Record<ResendItemStatus, string> = {
  [ResendItemStatus.NotSent]: 'dangerContainer',
  [ResendItemStatus.Sent]: 'successContainer',
  [ResendItemStatus.Cancelled]: 'warningContainer',
  [ResendItemStatus.Archived]: 'warningContainer',
  [ResendItemStatus.Read]: 'successContainer',
  [ResendItemStatus.Resent]: 'successContainer',
  [ResendItemStatus.Sending]: 'infoContainer',
  [ResendItemStatus.Bounced]: 'warningContainer',
  [ResendItemStatus.Delivered]: 'successContainer',
  [ResendItemStatus.Opened]: 'successContainer',
  [ResendItemStatus.ReportedAsSpam]: 'dangerContainer',
  [ResendItemStatus.Unsubscribed]: currentTheme.colors.statusContainerColor.uploadingContainer,
  [ResendItemStatus.Processing]: 'infoContainer',
};

export const ResendItemStatusIndicatorColorMap: Record<ResendItemStatus, string> = {
  [ResendItemStatus.NotSent]: 'danger',
  [ResendItemStatus.Sent]: 'success',
  [ResendItemStatus.Cancelled]: 'noAssignee',
  [ResendItemStatus.Archived]: 'noAssignee',
  [ResendItemStatus.Read]: 'success',
  [ResendItemStatus.Resent]: 'success',
  [ResendItemStatus.Sending]: 'info',
  [ResendItemStatus.Bounced]: 'warning',
  [ResendItemStatus.Delivered]: 'success',
  [ResendItemStatus.Opened]: 'success',
  [ResendItemStatus.ReportedAsSpam]: 'danger',
  [ResendItemStatus.Unsubscribed]: currentTheme.colors.statusColors.uploading,
  [ResendItemStatus.Processing]: 'info',
};

export const ResendItemStatusTitlesMap: Record<ResendItemStatus, string> = {
  [ResendItemStatus.Sent]: 'Sent',
  [ResendItemStatus.NotSent]: 'Not Sent',
  [ResendItemStatus.Resent]: 'Resent',
  [ResendItemStatus.Processing]: 'Processing',
  [ResendItemStatus.Sending]: 'Sending',
  [ResendItemStatus.Bounced]: 'Bounced',
  [ResendItemStatus.Delivered]: 'Delivered',
  [ResendItemStatus.Opened]: 'Opened',
  [ResendItemStatus.ReportedAsSpam]: 'Reported as spam',
  [ResendItemStatus.Unsubscribed]: 'Unsubscribed',
  [ResendItemStatus.Cancelled]: 'Cancelled',
  [ResendItemStatus.Archived]: 'Archived',
  [ResendItemStatus.Read]: 'Read',
};

export interface IResendStatusHistory {
  id: string;
  datetime: string;
  status: ResendItemStatus;
}

export interface IResendItem {
  id: string;
  date: string;
  time: string;
  subject: string;
  isResendable: boolean;
  destination: {
    sentTo: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zipCode?: string;
  };
  type: ResendItemType;
  status: ResendItemStatus;
  view?: string;
  templateId?: string;
  templateVariables?: ValuesMap<string | number | boolean>;
  historyList?: IResendStatusHistory[];
}
